import { createState } from '../context-utils';

export const cacheSelector = createState((state: CacheType) => {
  return state.store;
});
